import { memo, useLayoutEffect, useState } from 'react'
import { AnimatedSwitch, RouterPanel, usePanelHistoryTop } from 'weblite-router'
import { VisibilityHandler } from './components/visibility-handler'
import {
  JaryanPanel,
  KoolehPanel,
  MavakebPanel,
  RahkarPanel,
  RoomListPanel,
} from '$scenes/router-panels'
import { usePrevious } from '$common/react-hooks/use-previous'
import { NativeColors, useSetNativeColors } from '$logic/native-colors'

const panelsIndex = {
  roomList: 0,
  mavakeb: 1,
  jaryan: 2,
  kooleh: 3,
}

export const homePanelAPI = {
  setNativeColors(_colors: NativeColors) {},
}

export const Home = memo(() => {
  const { tab } = usePanelHistoryTop()?.state || {}
  const [overriddenNativeColors, setOverriddenNativeColors] =
    useState<NativeColors>({})

  useLayoutEffect(() => {
    homePanelAPI.setNativeColors = (newColors: NativeColors) =>
      setOverriddenNativeColors(colors => ({
        statusBar: newColors.statusBar || colors.statusBar,
        bottomSafeArea: newColors.bottomSafeArea || colors.bottomSafeArea,
      }))
  }, [])

  const prevTab = usePrevious(tab)
  const activeTab = tab === 'rahkar' && prevTab ? prevTab : tab

  useSetNativeColors(
    () => ({
      statusBar:
        tab === 'rahkar'
          ? '#000'
          : overriddenNativeColors?.statusBar || 'default',

      bottomSafeArea:
        tab === 'rahkar'
          ? '#000'
          : overriddenNativeColors?.bottomSafeArea || 'default',
    }),
    [tab, overriddenNativeColors],
    tab !== 'roomList',
  )

  return (
    <VisibilityHandler
      zIndex={1}
      considerIOSNotch
      style={{ transform: 'translate3d(0)' }} // NOTE: Do NOT remove this line
    >
      <AnimatedSwitch
        name="slide"
        activeKey={panelsIndex[activeTab as keyof typeof panelsIndex] || 0}
        keepAllMounted
      >
        <RoomListPanel.Portal>
          <RouterPanel />
        </RoomListPanel.Portal>

        <MavakebPanel.Portal>
          <RouterPanel />
        </MavakebPanel.Portal>

        <JaryanPanel.Portal>
          <RouterPanel />
        </JaryanPanel.Portal>

        <KoolehPanel.Portal>
          <RouterPanel />
        </KoolehPanel.Portal>
      </AnimatedSwitch>

      <RahkarPanel.Portal>
        <RouterPanel />
      </RahkarPanel.Portal>
    </VisibilityHandler>
  )
})
